import { render, staticRenderFns } from "./AamsReceptionRegInfo.vue?vue&type=template&id=7c608408&scoped=true&"
import script from "./AamsReceptionRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsReceptionRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c608408",
  null
  
)

export default component.exports